// src/services/authService.ts

import type { LoginPayload, TokenResponse } from '../types/auth'

const API_BASE = process.env.REACT_APP_API_BASE_URL ?? ''

/**
 * Envoie les identifiants à l'API pour obtenir un access/refresh token.
 * Lance une erreur si la requête échoue.
 */
export async function login(
  payload: LoginPayload
): Promise<TokenResponse> {
  const url = `${API_BASE}/api/auth/login`
  console.debug('[authService] login → POST', url, payload)

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  console.debug('[authService] login ← status', response.status)

  if (!response.ok) {
    let message = 'Erreur lors de la connexion.'
    try {
      const data = await response.json()
      if (data?.error) message = data.error
    } catch {
      /* ignore */
    }
    throw new Error(message)
  }

  const data: TokenResponse = await response.json()
  return data
}
